const store = 'roster';

export default {
    fullStore: [store],
    selectedTermBid: [store, 'selectedTermBid'],
    selectedSchoolBid: [store, 'selectedSchoolBid'],
    selectedInstructorBid: [store, 'selectedInstructorBid'],
    selectedClassBid: [store, 'selectedClassBid'],
    selectedStudentBid: [store, 'selectedStudentBid'],
    schools: [store, 'schools'],
    instructors: [store, 'instructors'],
    classes: [store, 'classes'],
    students: [store, 'students'],
    selectedClass: [
        [store, 'selectedClassBid'],
        [store, 'classes'],
        (selectedClassBid, classes) => {
            if (!selectedClassBid || !classes) return null;

            return classes.find((t) => t.get('bid') == selectedClassBid);
        },
    ],
};
